import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const handleLinkClick = () => setIsOpen(false);

  return (
    <header className='header'>
      <div className='header-container'>
        <a href='/' className='logo'>
          <img src={`${process.env.PUBLIC_URL}/img/logo-otwarte-pracownie-na-mazurach.svg`} alt='Logo' />
        </a>

        <nav className={`nav ${isOpen ? 'open' : ''}`}>
          <Link to='/o-wydarzeniu' onClick={handleLinkClick}>
            O wydarzeniu
          </Link>
          <Link to='/edycje' onClick={handleLinkClick}>
            Edycje
          </Link>
          <Link to='/zostan-partnerem' onClick={handleLinkClick}>
            Zostań partnerem
          </Link>
          <Link to='/media' onClick={handleLinkClick}>
            Dla mediów
          </Link>
          <Link to='/kontakt' onClick={handleLinkClick}>
            Kontakt
          </Link>

          <div className='icon-hamburger-container'><a
            href='https://www.instagram.com/otwarte_pracownie_na_mazurach'
            target='_blank'
            rel='noreferrer'
            aria-label='Instagram'
          >
            <img src={`${process.env.PUBLIC_URL}/img/ikona-ig.svg`} alt='Instagram' className='icon-hamburger' />
          </a>

            <a
              href='https://www.facebook.com/profile.php?id=100093374023915'
              target='_blank'
              rel='noreferrer'
              aria-label='Facebook'
            >
              <img src={`${process.env.PUBLIC_URL}/img/ikona-fb.svg`} alt='Facebook' className='icon-hamburger' />
            </a></div>
        </nav>

        <div className='icons'>
          <a
            href='https://www.instagram.com/otwarte_pracownie_na_mazurach'
            target='_blank'
            rel='noreferrer'
            aria-label='Instagram'
          >
            <img src={`${process.env.PUBLIC_URL}/img/ikona-ig.svg`} alt='Instagram' />
          </a>
          <a
            href='https://www.facebook.com/profile.php?id=100093374023915'
            target='_blank'
            rel='noreferrer'
            aria-label='Facebook'
          >
            <img src={`${process.env.PUBLIC_URL}/img/ikona-fb.svg`} alt='Facebook' />
          </a>
        </div>

        <button
          className={`hamburger ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label='Menu'
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}
